import React from 'react';
import PropTypes from 'prop-types';
import PropertyIcon, { hasIcon } from 'components/field/PropertyIcon';

const PropertyListIcon = (props) => {
    if (!props.record) {
        return null;
    }

    const { id } = props.record;

    if (!id) {
        return null;
    }

    if (!hasIcon(id)) {
        return null;
    }

    return <PropertyIcon id={ id } />;
};

PropertyListIcon.propTypes = {
    record: PropTypes.shape({
        id: PropTypes.number,
    }),
};

export default PropertyListIcon;



// WEBPACK FOOTER //
// ./src/pages/properties/list/PropertyListIcon.js